export default async function request(url, options) {
  if (!window.navigator.onLine) {
    return false;
  }

  try {
    const response = await fetch(url, options);
    return response.json();
  } catch (e) {
    console.log(e);
    return false;
  }
}
